import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type PaymentTransactionState = CommonTableState;

const initialState: PaymentTransactionState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            created: false,
            issuerId: false,
        },
        columnOrder: [
            "mrt-row-expand",
            "type",
            "amount",
            "credit",
            "accountType",
            "targetType",
            "description",
            "issuerId",
            "description",
            "transactionTime",
            "created",
        ],
        density: "compact",
    },
};

export const paymentTransactionSlice = createSlice({
    name: "paymentTransaction",
    initialState: initialState,
    reducers: {
        updatePaymentTransactionTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updatePaymentTransactionTableState } = paymentTransactionSlice.actions;

export default paymentTransactionSlice.reducer;
